import { ClientChatProps } from '@/interfaces/models/clientChat';
import { TakeAwayProps } from '@/interfaces/models/order';
import ClientChat from '@/models/clientChat';
import TakeAway from '@/models/takeAway';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat(
      ({ orders, chat }: { orders: TakeAwayProps[], chat: ClientChatProps | null }): { orders: TakeAway[], chat: ClientChat | null } => {
        return {
          orders: orders.map(TakeAway.createFromRequest),
          chat: null !== chat ? new ClientChat(chat) : null
        };
      }
    );
  }
};
